/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Freebsd_2Inputs */

const en_pc_dl_freebsd_2 = /** @type {(inputs: Pc_Dl_Freebsd_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extract it: tar -xzf pdfcraft-*-freebsd-x86_64.tar.gz`)
};

const zh_pc_dl_freebsd_2 = /** @type {(inputs: Pc_Dl_Freebsd_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解压：tar -xzf pdfcraft-*-freebsd-x86_64.tar.gz`)
};

/**
* | output |
* | --- |
* | "Extract it: tar -xzf pdfcraft-*-freebsd-x86_64.tar.gz" |
*
* @param {Pc_Dl_Freebsd_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_freebsd_2 = /** @type {((inputs?: Pc_Dl_Freebsd_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Freebsd_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_freebsd_2(inputs)
	return zh_pc_dl_freebsd_2(inputs)
});
export { pc_dl_freebsd_2 as "pc.dl.freebsd.2" }